import { render, staticRenderFns } from "./achaval-ferrer.vue?vue&type=template&id=45dc481e&scoped=true"
import script from "./achaval-ferrer.vue?vue&type=script&lang=js"
export * from "./achaval-ferrer.vue?vue&type=script&lang=js"
import style0 from "./achaval-ferrer.vue?vue&type=style&index=0&id=45dc481e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc481e",
  null
  
)

export default component.exports